import React from 'react';
import Accordion from 'core/components/Accordion';
import PCPInputs from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/PCPInputs';

export default function PatientPCPInfo() {
  return (
    <Accordion
      defaultExpanded
      header="Primary Care Physician"
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-2 populate-form gap-form-row flex flex-col w-full' }}
    >
      <div className="flex w-full gap-form-field items-center">
        <PCPInputs />
      </div>
    </Accordion>
  );
}
